import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BreadCrumsHeader from "../../common/BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Checkbox from "../../common/Checkbox";
import Pagination from "../../common/TablePagination";
import closeIcon from "../../../Assets/Icons/popupCloseIcon.svg";
import whiteTick from "../../../Assets/Icons/White Tick.svg";
import deleteImg from "../../../Assets/Images/deleteImg.svg";
import { ReactComponent as UncheckedIcon } from "../../../Assets/Icons/uncheckedWhiteBox.svg";
import { ReactComponent as UncheckedGreyIcon } from "../../../Assets/Icons/unCheckedGreyIcon.svg";
import Loader from "../../common/Loader";
import DetailsPopup from "../../common/DetailsPopup";
import infoIcon from "../../../Assets/Icons/infoIcon.svg";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import SearchBar from "../../common/SearchBar";
import debounce from "lodash.debounce";
import { Dropdown } from "antd";
import FilterPanel from "../../common/FilterPanel";
import DetailsModal from "../../common/DetailsModal";
import RejectOfferPopup from "../../common/RejectOfferPopup";
import crossIcon from "../../../Assets/Icons/cross.svg";
import {
  getMerchants,
  toggleMerchantStatus,
  getMerchantById,
  approveOrRejectMerchant,
} from "../../../services/merchantService";
import { deleteMerchantById } from "../../../services/merchantService";
import { getMerchantInvites } from "../../../services/onboardingService";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
import PopupContent from "../../Fundraiser/FundraiserReferralListTable/PopupContent";
import CancelPopup from "../../common/CancelPopup";
import { DatePicker } from "antd";
import Confirmation from "../../common/OfferList/Confirmation";
import AddIcon from "../../../Assets/Icons/AddIcon.svg";
import FilterButton from "../../common/FilterButton";
import ChangeLogoModal from "./ChangeLogoModal";

// Remove RangePicker and use DatePicker instead for better fit
// const { RangePicker } = DatePicker;

const AdminMerchantList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state?.merchantReducer?.loading);
  const fundraiserLoading = useSelector(
    (state) => state?.fundraiserReducer?.loading
  );

  const [allMerchants, setAllMerchants] = useState();
  const [fullMerchantsList, setFullMerchantsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [clickedOffer, setClickedOffer] = useState(null);
  const [reason, setReason] = useState("");
  const [infoClicked, setInfoClicked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [statusToggled, setStatusToggled] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showActionModal, setShowActionModal] = useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [openReasonBox, setOpenReasonBox] = useState(false);
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [isMerchantDetailOpen, setIsMerchantDetailOpen] = useState(false);
  const [showApprovalConfirm, setShowApprovalConfirm] = useState(false);
  const [selectedMerchantIds, setSelectedMerchantIds] = useState([]);
  const [showDeclineConfirm, setShowDeclineConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [merchantToDelete, setMerchantToDelete] = useState(null);
  const [customDate, setCustomDate] = useState([null, null]);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showChangeLogoModal, setShowChangeLogoModal] = useState(false);
  const [merchantForLogoChange, setMerchantForLogoChange] = useState(null);

  const [filterParams, setFilterParams] = useState({
    status: null,
    duration: null,
  });

  // Add these mappings
  const DURATION_MAP = {
    "Today": "DAY",
    "This Week": "WEEK",
    "This Month": "MONTH",
    "This Year": "YEAR",
    "Custom Date": "CUSTOM",
  };

  const [filterData, setFilterData] = useState([
    {
      id: "status",
      title: "Status",
      options: ["Approved", "In-Process"],
      multiSelect: false,
      valueMap: {
        Approved: "approved",
        "In-Process": "in-process",
      },
    },
    {
      id: "duration",
      title: "Time Period",
      options: ["Today", "This Week", "This Month", "This Year", "Custom Date"],
      defaultValue: null,
      multiSelect: false,
      valueMap: DURATION_MAP,
      customContent: (selected) => {
        return selected === "Custom Date" ? (
          <div className="mt-3 flex flex-col gap-2">
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">Start Date</label>
              <DatePicker
                value={customDate?.[0]}
                onChange={(date) => {
                  const newDates = [date, customDate?.[1]];
                  setCustomDate(newDates);
                }}
                style={{ width: '100%' }}
                placeholder="Start Date"
                format="YYYY-MM-DD"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">End Date</label>
              <DatePicker
                value={customDate?.[1]}
                onChange={(date) => {
                  const newDates = [customDate?.[0], date];
                  setCustomDate(newDates);
                }}
                style={{ width: '100%' }}
                placeholder="End Date"
                format="YYYY-MM-DD"
              />
            </div>
          </div>
        ) : null;
      }
    },
  ]);

  // Fix: Update filterData when customDate changes to avoid stale closures
  useEffect(() => {
    setFilterData((prevData) =>
      prevData.map((filter) => {
        if (filter.id === "duration") {
          return {
            ...filter,
            customContent: (selected) => {
              return selected === "Custom Date" ? (
                <div className="mt-3 flex flex-col gap-2">
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">Start Date</label>
                    <DatePicker
                      value={customDate?.[0]}
                      onChange={(date) => {
                        const newDates = [date, customDate?.[1]];
                        setCustomDate(newDates);
                      }}
                      style={{ width: '100%' }}
                      placeholder="Start Date"
                      format="YYYY-MM-DD"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <label className="text-[12px] font-medium text-gray-600">End Date</label>
                    <DatePicker
                      value={customDate?.[1]}
                      onChange={(date) => {
                        const newDates = [customDate?.[0], date];
                        setCustomDate(newDates);
                      }}
                      style={{ width: '100%' }}
                      placeholder="End Date"
                      format="YYYY-MM-DD"
                    />
                  </div>
                </div>
              ) : null;
            }
          };
        }
        return filter;
      })
    );
  }, [customDate]);

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        // For multi-select, initialize as array
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        // For single select, initialize as single value
        acc[filter.id] = filter.defaultValue ?? null;
      }
      return acc;
    }, {});
  };

  // Initialize selections with the initial state
  const [selections, setSelections] = useState(createInitialState(filterData));

  // Update the handleSelectionChange function
  const handleSelectionChange = (filterId, value) => {
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));
  };

  // Update the handleReset function
  const handleReset = () => {
    const initialState = createInitialState(filterData);
    setSelections(initialState);
    setFilterParams({
      status: null,
      duration: null,
    });
    setCustomDate([null, null]);
  };

  // When applying filters, you can now access both category ID and subcategory IDs array
  const handleApply = () => {
    // Create a new object for mapped filter parameters
    const mappedFilterParams = {};

    filterData.forEach((filter) => {
      const selectedValue = selections[filter.id];
      if (
        selectedValue !== null &&
        selectedValue !== undefined &&
        selectedValue !== "" &&
        !(Array.isArray(selectedValue) && selectedValue.length === 0)
      ) {
        if (filter.id === "duration" && selectedValue === "Custom Date" && customDate && (customDate[0] || customDate[1])) {
          mappedFilterParams.duration = "CUSTOM";
          mappedFilterParams.startDate = customDate[0]?.format("YYYY-MM-DD");
          mappedFilterParams.endDate = customDate[1]?.format("YYYY-MM-DD");
        } else if (filter.valueMap) {
          mappedFilterParams[filter.id] = filter.multiSelect
            ? selectedValue.map((val) => filter.valueMap[val])
            : filter.valueMap[selectedValue];
        } else {
          mappedFilterParams[filter.id] = selectedValue;
        }
      }
    });
    setFilterParams(mappedFilterParams);
    setOpen(false);
  };

  // Handle cancel button click
  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  useEffect(() => {
    if (open) {
      document.body.classList.add("dropdown-open");
    } else {
      document.body.classList.remove("dropdown-open");
    }

    return () => {
      document.body.classList.remove("dropdown-open");
    };
  }, [open]);

  const items = [
    {
      title: "Merchants",
    },
    {
      title: "Merchant List",
    },
  ];

  const columns = [
    {
      name: "No.",
    },
    {
      name: "Name",
    },
    {
      name: "Date joined",
    },
    {
      name: "Email",
    },
    {
      name: "Contact",
    },
    {
      name: "Address",
    },
    {
      name: "Status",
    },
    {
      name: "Actions",
    },
  ];

  // Function to check if a merchant is in-process (incomplete signup)
  const isInProcess = (merchant) => {
    const status = merchant?.status?.toLowerCase();
    // In this project, everything that is not explicitly "approved" is considered "In-Process" in the UI
    return status !== "approved";
  };

  const updatePageSlice = (data, page) => {
    if (!data) return;
    const startIndex = (page - 1) * 50;
    const endIndex = startIndex + 50;
    setAllMerchants(data.slice(startIndex, endIndex));
  };

  const getMerchantsData = async (search) => {
    try {
      // Detect search type based on input pattern
      let searchParams = {
        limit: 1000, // Fetch all for 1000 for client-side multi-source filtering
        // If status is "approved", we can let backend filter it for performance.
        // For "in-process", we need to fetch all to merge with invitations.
        status: filterParams.status === 'in-process' ? null : (filterParams.status || null),
      };

      if (search && search.trim()) {
        const searchTerm = search.trim();

        // Check if it's a contact number (contains only digits, spaces, +, -, (, ))
        const isContactNumber = /^[\d\s+\-()]+$/.test(searchTerm);

        // Check if it's a date (contains / or - and digits)
        const isDate = /^[\d/\-]+$/.test(searchTerm) && (searchTerm.includes('/') || searchTerm.includes('-'));

        if (isContactNumber) {
          searchParams.contactSearch = searchTerm;
        } else if (isDate) {
          searchParams.dateSearch = searchTerm;
        } else {
          searchParams.search = searchTerm;
        }
      }

      // Remove null values to avoid sending empty parameters
      Object.keys(searchParams).forEach((key) =>
        searchParams[key] === null ? delete searchParams[key] : {}
      );

      const merchantsPromise = await dispatch(getMerchants(searchParams))?.unwrap();

      let combinedData = [];
      if (merchantsPromise?.success === true) {
        combinedData = [...(merchantsPromise?.data || [])];
      }

      // Merge invitations that have started (have a business name) into the Merchant List
      if (!filterParams.status || filterParams.status === 'in-process') {
        try {
          const invitesPromise = await dispatch(getMerchantInvites({ limit: 1000 }))?.unwrap();
          if (invitesPromise?.success === true) {
            const invitationsAsMerchants = (invitesPromise?.data || [])
              // Include in Merchant List if they have a name OR have moved beyond the initial "pending" state.
              .filter(invite => invite.businessName || invite.business_name || invite.status === "accepted" || invite.status === "completed" || invite.status === "approved")
              .map(invite => ({
                ...invite,
                _id: invite._id || invite.id,
                businessName: invite.businessName || invite.business_name || "Merchant (No Name)",
                status: invite.status || "invited",
                isFromInvitation: true
              }));

            // Merge and avoid duplicates by email
            invitationsAsMerchants.forEach(invite => {
              const email = (invite.email || invite.user?.email || "").toLowerCase();
              if (!email) return;

              const exists = combinedData.find(m =>
                (m.email?.toLowerCase() === email) ||
                (m.user?.email?.toLowerCase() === email) ||
                (m.businessEmail?.toLowerCase() === email) ||
                (m.business_email?.toLowerCase() === email)
              );
              if (!exists) {
                combinedData.push(invite);
              }
            });
          }
        } catch (error) {
          console.error("Failed to fetch invitations for Merchant List:", error);
        }
      }

      if (combinedData.length > 0 || merchantsPromise?.success === true) {
        // Helper to check for the internal "Pending_..." placeholder strings generated by the backend
        const isInternalPlaceholder = (val) => typeof val === 'string' && val.startsWith("Pending_");

        // 1. Filter merchants based on status
        let filteredMerchants = combinedData.filter((merchant) => {
          // Rule: Never show records with internal "Pending_..." placeholder names in the Merchant List.
          // These stay in the Invitation List until a real name is provided.
          if (isInternalPlaceholder(merchant.businessName) || isInternalPlaceholder(merchant.business_name)) {
            return false;
          }

          // If a specific status filter is active, follow it
          if (filterParams.status) {
            if (filterParams.status === 'in-process') {
              return isInProcess(merchant);
            }
            return merchant?.status?.toLowerCase() === filterParams.status;
          }
          // If no filter, show ALL merchants (completed AND in-process)
          return true;
        });

        // 2. Filter by duration if provided
        if (filterParams.duration) {
          const now = new Date();
          let start = new Date();
          let end = new Date();

          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 999);

          if (filterParams.duration === 'DAY') {
            // Already set
          } else if (filterParams.duration === 'WEEK') {
            start.setDate(now.getDate() - now.getDay());
            start.setHours(0, 0, 0, 0);
          } else if (filterParams.duration === 'MONTH') {
            start.setDate(1);
            start.setHours(0, 0, 0, 0);
          } else if (filterParams.duration === 'YEAR') {
            start.setMonth(0, 1);
            start.setHours(0, 0, 0, 0);
          } else if (filterParams.duration === 'CUSTOM' && filterParams.startDate && filterParams.endDate) {
            start = new Date(filterParams.startDate);
            start.setHours(0, 0, 0, 0);
            end = new Date(filterParams.endDate);
            end.setHours(23, 59, 59, 999);
          }

          if (filterParams.duration !== 'CUSTOM' || (filterParams.startDate && filterParams.endDate)) {
            filteredMerchants = filteredMerchants.filter(merchant => {
              const dateSource = merchant.createdAt || merchant.created_at || merchant.notifiedAt || merchant.updatedAt || merchant.date;
              if (!dateSource) return false;
              const merchantDate = new Date(dateSource);
              if (isNaN(merchantDate.getTime())) return false;
              return merchantDate >= start && merchantDate <= end;
            });
          }
        }

        // 3. SORT BY DATE DESCENDING (Latest on top)
        filteredMerchants.sort((a, b) => {
          const dateA = new Date(a.createdAt || a.created_at || a.notifiedAt || a.updatedAt || 0);
          const dateB = new Date(b.createdAt || b.created_at || b.notifiedAt || b.updatedAt || 0);
          return dateB - dateA;
        });

        setFullMerchantsList(filteredMerchants);

        // Calculate total pages based on filtered list
        const total = Math.ceil((filteredMerchants?.length || 0) / 50);
        setTotalPages(total || 1);
        setCount(filteredMerchants?.length || 0);

        // Update current page slice
        const newPage = (search || filterParams.status || filterParams.duration) ? 1 : currentPage;
        setCurrentPage(newPage);
        updatePageSlice(filteredMerchants, newPage);
      }
    } catch (error) {
      console.error("Error in getMerchantsData:", error);
    }
  };

  useEffect(() => {
    getMerchantsData(searchQuery);
    // eslint-disable-next-line
  }, [statusToggled, filterParams]);

  useEffect(() => {
    if (fullMerchantsList.length > 0) {
      updatePageSlice(fullMerchantsList, currentPage);
    }
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // Scroll to top of merchant list when changing pages
    const container = document.getElementById('merchant-list-container');
    if (container) {
      container.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // const handleToggle = async (id) => {
  //   try {
  //     const togglePromise = await dispatch(
  //       toggleOfferStatus({ id: id })
  //     ).unwrap();
  //     if (togglePromise?.success === true) {
  //       getOffersData();
  //     }
  //   } catch (error) {
  //     console.error("Error toggling location status:", error);
  //   }
  // };

  const handleCloseInfo = () => {
    setInfoClicked(false);
    setClickedOffer(null);
  };

  const handleInfoClick = (offer) => {
    setClickedOffer(offer);
    setInfoClicked(true);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((query) => {
        getMerchantsData(query);
      }, 500),
    [filterParams]
  );

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    debouncedSearch(value);
  };

  const getSelectableOffers = () => {
    return allMerchants || [];
  };

  const handleSelectAll = () => {
    const selectableOffers = getSelectableOffers();

    if (
      selectableOffers.length > 0 &&
      selected.length === selectableOffers.length
    ) {
      setSelected([]);
    } else {
      const newSelected = selectableOffers.map((offer) => offer._id);
      setSelected(newSelected);
    }
  };

  const handleSelectOne = (event, id, status) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter((selectedId) => selectedId !== id);
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Allow selection for all statuses (Approved/Declined can be moved to Pending)
  const isSelectable = (status) => {
    return true;
  };

  const handleBulkApprove = () => {
    setShowApprovalConfirm(true);
  };

  const handleApproveConfirm = async () => {
    setShowApprovalConfirm(false);
    try {
      const payload = {
        ids: selected,
        status: "approved",
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload)
      )?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setSelected([]);
      }
    } catch (error) {
      console.error("Error approving offers:", error);
    }
  };

  const handleBulkDecline = () => {
    setShowDeclineConfirm(true);
  };

  const handleDeclineConfirm = async () => {
    setShowDeclineConfirm(false);
    try {
      const payload = {
        ids: selected,
        status: "declined",
        reason: "Bulk declined",
      };
      const statusPromise = await dispatch(
        approveOrRejectMerchant(payload)
      )?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setSelected([]);
      }
    } catch (error) {
      console.error("Error declining offers:", error);
    }
  };

  // Move selected merchants to pending
  const handleBulkPending = async () => {
    try {
      const payload = {
        ids: selected,
        status: "pending",
        reason: "Moved to pending",
      };
      const statusPromise = await dispatch(approveOrRejectMerchant(payload))?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setSelected([]);
        setShowActionModal(false);
      }
    } catch (error) {
      console.error("Error setting pending merchants:", error);
    }
  };

  // Single approve/decline from detail modal
  const handleApproveSingle = async (id) => {
    try {
      const payload = { ids: [id], status: "approved" };
      const statusPromise = await dispatch(approveOrRejectMerchant(payload))?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false);
      }
    } catch (e) {
      console.error("Error approving merchant:", e);
    }
  };

  const handleDeclineSingle = async (id) => {
    try {
      const payload = { ids: [id], status: "declined", reason: "Declined from details" };
      const statusPromise = await dispatch(approveOrRejectMerchant(payload))?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false);
      }
    } catch (e) {
      console.error("Error declining merchant:", e);
    }
  };

  const handleReviewStatus = async (merchantId, newStatus) => {
    try {
      const payload = { ids: [merchantId], status: newStatus, reason: "Status reviewed by admin" };
      const statusPromise = await dispatch(approveOrRejectMerchant(payload))?.unwrap();
      if (statusPromise?.success) {
        setStatusToggled(!statusToggled);
        setIsMerchantDetailOpen(false);
        setShowReviewModal(false);
      }
    } catch (e) {
      console.error("Error reviewing merchant status:", e);
    }
  };

  const handleShowReviewModal = () => {
    setShowReviewModal(true);
  };

  const handleCloseReviewModal = () => {
    setShowReviewModal(false);
  };

  const handleDeclineCancel = () => {
    setShowDeclineConfirm(false);
  };
  const handleApproveCancel = () => {
    setShowApprovalConfirm(false);
  };

  useEffect(() => {
    if (selected.length > 0) {
      setShowActionModal(true);
    } else {
      setShowActionModal(false);
    }
  }, [selected]);

  // Calculate count of selectable items for "Select All" checkbox
  const selectableCount = getSelectableOffers().length;
  const allSelectableSelected =
    selectableCount > 0 && selected.length === selectableCount;

  // Determine which bulk action buttons to show based on selected statuses
  const selectedStatuses = selected
    .map((id) => allMerchants?.find((m) => m._id === id)?.status)
    .filter(Boolean)
    .map((s) => s?.toLowerCase());
  const hasPendingSelected = selectedStatuses.includes("pending");
  const hasApprovedDeclinedSelected = selectedStatuses.some(status => status === "approved" || status === "declined");

  // Show approve/decline buttons only if there are pending items selected
  const showApproveDecline = selected.length > 0 && hasPendingSelected;
  // Show move to pending only if there are approved/declined items selected
  const showMoveToPending = selected.length > 0 && hasApprovedDeclinedSelected;

  const handleMerchantDisable = async () => {
    setOpenReasonBox(false);
    const togglePromise = await dispatch(
      toggleMerchantStatus({ id: selectedMerchant?._id, reason: reason })
    ).unwrap();
    if (togglePromise?.success === true) {
      setStatusToggled(!statusToggled);
      setSelectedMerchant(null);
    }
  };

  const handleCloseReject = () => {
    setSelectedMerchant(null);
    setOpenReasonBox(false);
  };

  const fetchMerchantDetails = async (merchantId) => {
    try {
      const merchantDetailsPromise = await dispatch(
        getMerchantById({ id: merchantId, silent: true })
      )?.unwrap();
      if (merchantDetailsPromise?.success === true) {
        setMerchantDetails(merchantDetailsPromise?.data);
      }
    } catch (error) {
      console.error("Error fetching merchant details:", error);
    }
  };

  const openMerchantPopup = (merchantId) => {
    setMerchantDetails(null);
    setIsMerchantDetailOpen(true);
    fetchMerchantDetails(merchantId);
  };

  const closeMerchantPopup = () => {
    setIsMerchantDetailOpen(false);
  };

  const handleDeleteMerchant = (id) => {
    setMerchantToDelete(id);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const deletePromise = await dispatch(
        deleteMerchantById({ id: merchantToDelete })
      )?.unwrap();
      if (deletePromise?.success === true) {
        setIsMerchantDetailOpen(false);
        getMerchantsData(searchQuery);
      }
    } catch (error) {
      console.error("Error deleting merchant:", error);
    } finally {
      setShowDeleteConfirm(false);
      setMerchantToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setMerchantToDelete(null);
  };

  const handleOpenChangeLogoModal = (merchant) => {
    setMerchantForLogoChange(merchant);
    // Hide the View Details modal temporarily
    setIsMerchantDetailOpen(false);
    // Small delay to ensure smooth transition
    setTimeout(() => {
      setShowChangeLogoModal(true);
    }, 100);
  };

  const handleCloseChangeLogoModal = () => {
    setShowChangeLogoModal(false);
    setMerchantForLogoChange(null);
    // Show the View Details modal back with animation
    setTimeout(() => {
      setIsMerchantDetailOpen(true);
    }, 100);
  };

  const handleLogoChangeSuccess = () => {
    // Refresh merchant data after logo change
    getMerchantsData(searchQuery);
    // If the details modal was open, refresh the merchant details
    if (merchantDetails?._id) {
      fetchMerchantDetails(merchantDetails._id);
    }
  };

  return (
    <>
      {(loading === true || fundraiserLoading === true) && <Loader />}
      {infoClicked === true && (
        <DetailsPopup
          content={clickedOffer?.reason}
          handleClose={handleCloseInfo}
          icon={infoIcon}
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
        />
      )}
      {openReasonBox === true && (
        <RejectOfferPopup
          icon={crossIcon}
          content={
            "Could you please provide the reason for disabling this merchant?"
          }
          popupClassName={"w-[400px] sm:w-[500px] pb-4"}
          handleClose={handleCloseReject}
          setReason={setReason}
          handleOfferRejection={handleMerchantDisable}
        />
      )}
      {isMerchantDetailOpen && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          animation: 'fadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
        }}>
          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideIn {
                from { transform: translateY(-20px) scale(0.95); opacity: 0; }
                to { transform: translateY(0) scale(1); opacity: 1; }
              }
            `}
          </style>
          <div style={{
            animation: 'slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <DetailsModal
              handleClose={closeMerchantPopup}
              content={<PopupContent merchantDetails={merchantDetails} onDelete={handleDeleteMerchant} onApprove={(id) => handleApproveSingle(id)} onDecline={(id) => handleDeclineSingle(id)} onReviewStatus={handleReviewStatus} onShowReviewModal={handleShowReviewModal} onChangeLogo={handleOpenChangeLogoModal} />}
              popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[728px]"
            />
          </div>
        </div>
      )}
      {showApprovalConfirm && (
        <CancelPopup
          handleNo={handleApproveCancel}
          handleYes={handleApproveConfirm}
          heading="Approve Offers"
          content="Do you really want to approve all selected offers?"
          confirmation={true}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      {showDeclineConfirm && (
        <CancelPopup
          handleNo={handleDeclineCancel}
          handleYes={handleDeclineConfirm}
          heading="Decline Offers"
          content="Do you really want to decline all selected offers?"
          confirmation={false}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      {showDeleteConfirm && (
        <CancelPopup
          handleNo={handleDeleteCancel}
          handleYes={handleDeleteConfirm}
          heading="Delete Merchant"
          content="Are you sure you want to delete this merchant profile? This action cannot be undone."
          image={deleteImg}
          confirmation={false}
          popupClassName="w-[300px] sm:w-[420px] h-[224px] sm:h-[220px]"
        />
      )}
      {showChangeLogoModal && merchantForLogoChange && (
        <ChangeLogoModal
          merchantDetails={merchantForLogoChange}
          onClose={handleCloseChangeLogoModal}
          onSuccess={handleLogoChangeSuccess}
        />
      )}
      <div className="flex justify-between col-span-12">
        <BreadCrumsHeader heading="Merchant List" items={items} />
        <div className="flex gap-3 items-center">
          {/* In-Progress Merchants button removed as per request to merge lists */}
        </div>
      </div>
      <div className="w-full flex justify-between items-center mt-4">
        <SearchBar
          parentDivClass="w-[65%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative"
          inputClassName="searchBar w-full p-3 text-[14px] font-poppins font-[400] outline-none"
          iconClassName="absolute sm:right-[5%] sm:bottom-[25%] lg:right-[3%]"
          placeholder="Search"
          value={searchQuery}
          handleChange={(e) => handleSearchChange(e.target.value)}
        />
        <Dropdown
          overlay={
            <FilterPanel
              filterData={filterData}
              selections={selections}
              handleApply={handleApply}
              handleCancel={handleCancel}
              handleReset={handleReset}
              handleSelectionChange={handleSelectionChange}
            />
          }
          trigger={["click"]}
          open={open}
          onOpenChange={handleOpenChange}
          placement="bottomRight"
          overlayStyle={{
            minWidth: "320px",
            maxHeight: "80vh",
            zIndex: 1000,
          }}
          overlayClassName="filter-dropdown-overlay"
        >
          <FilterButton isOpen={open} />
        </Dropdown>
      </div>
      <div id="merchant-list-container" className="col-span-12 mt-4">
        <TableContainer style={{ width: "100%", overflowX: "auto" }}>
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {/* <TableCell className="!border-b-0">
                  <Checkbox
                    checked={allSelectableSelected}
                    onChecked={handleSelectAll}
                    divClassName="flex items-center"
                    UncheckedIcon={UncheckedIcon}
                    checkClassName={"!w-[22px] !h-[22px]"}
                  />
                </TableCell> */}
                {columns
                  .filter((column) => !(filterParams.status === "in-process" && column.name === "Actions"))
                  .map((column) => {
                    return (
                      <TableCell key={column.name} className="!text-[#FFFFFF]">
                        {column.name}
                      </TableCell>
                    );
                  })}
              </TableRow>
            </TableHead>

            <TableBody>
              {allMerchants?.map((merchant, index) => {
                console.log('merchant', merchant)
                const isItemSelected = isSelected(merchant._id);
                const itemSelectable = isSelectable(merchant.status);
                return (
                  <TableRow
                    key={merchant._id}
                    className="h-[50px]"
                    sx={{
                      boxShadow: "0px 4px 4px 0px #00000040",
                      backgroundColor:
                        (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                    }}
                  >
                    {/* <TableCell>
                      <Checkbox
                        checked={isItemSelected}
                        onChecked={(event) =>
                          handleSelectOne(event, merchant._id, merchant.status)
                        }
                        divClassName={`flex items-center ${!itemSelectable
                          ? "opacity-50 !cursor-not-allowed"
                          : ""
                          }`}
                        checkClassName={`!w-[22px] !h-[22px] ${!itemSelectable
                          ? "opacity-50 !cursor-not-allowed"
                          : ""
                          }`}
                        disabled={!itemSelectable}
                      />
                    </TableCell> */}
                    <TableCell className="max-w-[50px]">{(currentPage - 1) * 50 + index + 1}</TableCell>
                    <TableCell
                      title={merchant?.businessName}
                      className="max-w-[120px] truncate"
                    >
                      {merchant?.businessName || "N/A"}
                    </TableCell>
                    <TableCell
                      title={merchant?.createdAt || merchant?.created_at || merchant?.notifiedAt}
                      className="max-w-[120px] truncate"
                    >
                      {
                        separateDateTimeAndConvertToLocale(merchant?.createdAt || merchant?.created_at || merchant?.notifiedAt)
                          ?.localDate || "N/A"
                      }
                    </TableCell>
                    <TableCell
                      title={merchant?.user?.email || merchant?.email}
                      className="max-w-[140px] truncate"
                    >
                      {merchant?.user?.email || merchant?.email || "N/A"}
                    </TableCell>
                    <TableCell
                      title={merchant?.contactPersonNumber}
                      className="max-w-[120px] truncate"
                    >
                      {merchant?.contactPersonNumber || "N/A"}
                    </TableCell>
                    <TableCell
                      title={merchant?.address}
                      className="max-w-[180px] truncate"
                    >
                      {merchant?.address || "N/A"}
                    </TableCell>
                    <TableCell className="max-w-[110px]">
                      <Confirmation
                        status={isInProcess(merchant) ? "in-process" : "approved"}
                        handleInfoClick={() => handleInfoClick(merchant)}
                      />
                    </TableCell>
                    {filterParams.status !== "in-process" && (
                      <TableCell className="max-w-[130px]">
                        {!isInProcess(merchant) && (
                          <button
                            className="flex justify-center items-center border border-[#00ADEF] rounded-[6px] p-3 h-[34px]"
                            onClick={() => openMerchantPopup(merchant?._id)}
                          >
                            <span className="font-[600] text-[14px] text-[#00ADEF] font-poppins leading-[22px]">
                              View Details
                            </span>
                          </button>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />

        {/* {showActionModal && (
          <div
            className="fixed bottom-16 left-[57%] transform -translate-x-1/2 bg-white rounded-[6px] px-4 h-[60px] flex items-center gap-4 z-50 text-[14px] font-[600] text-[#303030] border border-[#0000001A]"
            style={{ boxShadow: "0px 4px 20px 0px #00000029" }}
          >
            <div className="flex items-center gap-2">
              <span className="!text-[12px] !font-[500] !text-[#000000] border border-[#2A35484D] rounded-[4px] w-[24px] h-[24px] flex items-center justify-center">
                {selected.length}
              </span>
              <span className="!font-[500]">Selected</span>
            </div>
            <div className="flex items-center gap-16">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={allSelectableSelected}
                    onChecked={handleSelectAll}
                    divClassName="flex items-center"
                    UncheckedIcon={UncheckedGreyIcon}
                    checkClassName={"!w-[22px] !h-[22px]"}
                  />
                  <span className="whitespace-nowrap !font-[500]">
                    Select All
                  </span>
                </div>
                {showApproveDecline && (
                  <>
                    <button
                      onClick={handleBulkApprove}
                      className="bg-[#00ADEF] text-white h-[38px] whitespace-nowrap pl-4 pr-8 py-1 rounded-[6px] flex items-center gap-2"
                    >
                      <img
                        src={whiteTick}
                        alt="tick"
                        className="h-[16px] w-[16px]"
                      />
                      Approve Merchants
                    </button>
                    <button
                      onClick={handleBulkDecline}
                      className="border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap"
                    >
                      Decline Merchants
                    </button>
                  </>
                )}
                {showMoveToPending && (
                  <button
                    onClick={handleBulkPending}
                    className="border border-[#00ADEF] text-[#00ADEF] h-[38px] px-4 py-1 rounded-[6px] whitespace-nowrap"
                  >
                    Move to Pending
                  </button>
                )}
              </div>
              <button
                onClick={() => setSelected([])}
                className="w-[10px] h-[10px]"
              >
                <img src={closeIcon} alt="Close" className="w-full h-full" />
              </button>
            </div>
          </div>
        )} */}

        {/* Review Status Modal */}
        {/* {showReviewModal && (
          <div className="popup-container" style={{ zIndex: 9999 }}>
            <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4 shadow-xl border border-[#00ADEF]">
              <h3 className="text-lg font-semibold mb-4 text-center">Review Status</h3>
              <p className="text-gray-600 mb-6 text-center">
                Are you sure you want to change the status from{" "}
                <span className="font-semibold capitalize">{merchantDetails?.status}</span> to{" "}
                <span className="font-semibold">Pending</span>?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={handleCloseReviewModal}
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleReviewStatus(merchantDetails?._id, "pending")}
                  className="flex-1 px-4 py-2 bg-[#00ADEF] text-white rounded-md hover:bg-[#0088CC]"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};

export default AdminMerchantList;
